<template>
    <Modal v-if="visible" :hideActions="true" :allowClose="true" @modal:close="handleClose()">
        <template #body>
            <div class="text-[#073B5D] font-[Inter] text-2xl font-semibold">Select a Resume Template</div>
            <div class="text-[#073B5D] font-[Inter] font-normal mt-2.5 text-sm">Click to select a resume from the {{ templates.length }} templates, then click on next to customize it with ResumAI!</div>

            <div class="flex flex-col gap-y-6">
                <div class="grid grid-cols-2 gap-4 mt-6">
                    <div v-for="item of templates" :key="item.name" :class="['h-[228px] bg-white rounded', {'border border-[#c2c4c6]': new String(item.name).toLocaleLowerCase()!=currentSelectedTemplate, 'border border-[#2A8176]': new String(item.name).toLocaleLowerCase()==currentSelectedTemplate }]" @click="() => handleSelect(item.name)">
                        <div class="overflow-hidden w-full h-[185px] py-3 px-2">
                            <img :alt="item.name" :src="`/storage/${item.preview}`">
                        </div>
                        <div class="flex flex-row items-center px-2">
                            <span class="text-[#073B5D] font-[Roboto] text-base font-medium text-ellipsis whitespace-nowrap overflow-hidden w-full">{{ local_names[new String(item.name).toLocaleLowerCase()] }}</span>
                            <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M12.4642 12.3658H1.96423V1.86584H7.21423V0.365845H1.96423C1.13173 0.365845 0.464233 1.04084 0.464233 1.86584V12.3658C0.464233 13.1908 1.13173 13.8658 1.96423 13.8658H12.4642C13.2892 13.8658 13.9642 13.1908 13.9642 12.3658V7.11585H12.4642V12.3658ZM8.71423 0.365845V1.86584H11.4067L4.03423 9.23835L5.09173 10.2958L12.4642 2.92335V5.61585H13.9642V0.365845H8.71423Z" fill="#929497"/>
                            </svg>
                        </div>
                    </div>
                </div>
    
                <div class="w-full my-4">
                    <won-button @click="() => handleNext()" class="w-full">
                        <svg v-if="submitting" class="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                            <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                            <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                        </svg>
                        Next
                    </won-button>
                </div>
            </div>
        </template>
    </Modal>
</template>

<script setup>
import { onMounted, toRefs, ref } from 'vue'

import Modal from "../components/modal.vue";
import WonButton from '../components/won-button'

const props = defineProps({
    templates: {
        type: Array,
        required: true
    },
    visible: {
        type: Boolean,
        default: false,
    },
    currentTemplate: {
        type: String,
        default: localStorage.getItem('defaultTemplate')
    }
})

const local_names = {
    'basic': 'Wonsulting Resume',
    'standart': 'UW Standart Resume',
    'technical': 'UW Technical Resume',
}

const { visible, currentTemplate, templates } = toRefs(props)
const emit = defineEmits(['change', 'close'])

const submitting = ref(false)
const currentSelectedTemplate = ref(currentTemplate.value)

onMounted(async() => {
    document.onkeydown = function(e) {
        if(e.key == 'Escape' && visible.value) {
            handleClose()
        }
    }
})

const handleSelect = (template) => {
    currentSelectedTemplate.value = new String(template).toLowerCase()
}

const handleNext = () => {
    submitting.value = true
    setTimeout(() => {
        handleClose()
        submitting.value = false

        emit("change", { template: currentSelectedTemplate.value });
    }, 500)
}

const handleClose = () => {
    emit("close");
}
</script>
